
class SamplePack {
    constructor(name=undefined, samples=[], tags=[], sampleToSlices={}) {
        this.samples = samples;
        this.tags = tags;
        this.name = name;
        this.sampleToSlices = sampleToSlices;
        this.timestamp = undefined;
        this.isArchived = false;
        this.id = undefined;
    }

    getJson() {
        return {
            samples: this.samples,
            sampleToSlices: this.sampleToSlices,
            name: this.name,
            tags: this.tags,
            timestamp: this.timestamp === undefined ? Math.floor(Date.now()) : this.timestamp,
            isArchived: this.isArchived,
            id: this.id
        };
    }

    fromJson(json) {
        if ('sampleToSlices' in json) {
            this.sampleToSlices = json.sampleToSlices;
        }

        if ('name' in json) {
            this.name = json.name;
        }

        if ('samples' in json) {
            this.samples = json.samples;
        }

        if ('tags' in json) {
            this.tags = json.tags;
        }

        if ('timestamp' in json) {
            this.timestamp = new Date(json.timestamp);
        }

        if ('isArchived' in json) {
            this.isArchived = json.isArchived;
        }

        if ('id' in json) {
            this.id = json.id;
        }

        return this;
    }
}

export default SamplePack;
